import { createBemed } from "react-bemed";

export const bemed = createBemed({
    prefix: "vs-",
    className: "vs-bemed",
});
